import { UserRole } from '../models/user.model';

export const HELP_TOPIC_IDS = [
  'dashboard',
  'children-list',
  'child-form',
  'child-detail',
  'child-progress',
  'assessment-list',
  'assessment-edit',
  'assessment-review',
  'assessment-view',
  'educators',
  'settings',
  'profile',
  'account-access',
  'default',
] as const;

export type HelpTopicId = (typeof HELP_TOPIC_IDS)[number];
export type RouteHelpTopicId = Exclude<HelpTopicId, 'account-access' | 'default'>;
export type AssessmentHelpRole = Extract<UserRole, 'EDUCATOR' | 'SITEMANAGER' | 'SUPERUSER'>;

const HELP_TOPIC_SET = new Set<string>(HELP_TOPIC_IDS);

export function isHelpTopicId(value: string | null | undefined): value is HelpTopicId {
  return typeof value === 'string' && HELP_TOPIC_SET.has(value);
}

export function isAssessmentHelpRole(role: UserRole | null): role is AssessmentHelpRole {
  return role === 'EDUCATOR' || role === 'SITEMANAGER' || role === 'SUPERUSER';
}

export function resolveHelpTopic(
  rawTopic: string | null | undefined,
  role: UserRole | null
): HelpTopicId {
  if (!isAssessmentHelpRole(role)) {
    return 'account-access';
  }

  if (!isHelpTopicId(rawTopic)) {
    return 'default';
  }

  return rawTopic === 'account-access' ? 'default' : rawTopic;
}
